module.exports = __webpack_public_path__ + "static/media/coupon-bg-background.e8357018.png";